import type { DocumentKind } from "@common/client"

export const TEMPLATES_PERMISSION = "document_template:read"

export const KIND_LABELS: Record<DocumentKind, string> = {
  quote: "Quote",
  work_order: "Work pack",
  task_card: "Task card",
  due_list: "Due list",
  squawk_card: "Squawk card",
  squawk_list: "Squawk list",
}

export const KIND_DESCRIPTIONS: Record<DocumentKind, string> = {
  quote: "The quote PDF sent to customers",
  work_order: "The work pack cover and task list for a work order",
  task_card: "One card per task, with steps, parts and tools to sign off",
  due_list: "The due list of a saved forecast",
  squawk_card:
    "One card per squawk, with parts and labor to fill in and sign off",
  squawk_list: "A list of squawks grouped by work order",
}

export function isDocumentKind(value: string): value is DocumentKind {
  return Object.keys(KIND_LABELS).includes(value)
}
